import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { RepeaterForm } from "../Forms/RepeaterForm.tsx";

export const RepeaterDrawer = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Repeater} title={t("nodes.repeater.drawers.title")}>
            <RepeaterForm formId={FormId.RepeaterForm} />
        </BaseConnectionCreatorDrawer>
    );
};
